export const animateUp = (animationUp, animationDown) => {
  if (animationUp.weight < 1) animationUp.setEffectiveWeight(animationUp.weight + 0.02);
  if (animationDown.weight > 0) animationDown.setEffectiveWeight(animationDown.weight - 0.02);
};

export const animateDown = (animationUp, animationDown) => {
  if (animationUp.weight > 0) animationUp.setEffectiveWeight(animationUp.weight - 0.02);
  if (animationDown.weight < 1) animationDown.setEffectiveWeight(animationDown.weight + 0.02);
};

export const animateCenter = (animationUp, animationDown) => {
  if (animationUp.weight > 0) animationUp.setEffectiveWeight(animationUp.weight - 0.02);
  if (animationDown.weight > 0) animationDown.setEffectiveWeight(animationDown.weight - 0.02);
};
